import { FC } from 'react';
import Accordion from 'components/reuseable/accordion';
// -------- data -------- //
import * as All from 'data/keywords';

// ============================================================
type Faq2Props = {
  title1: string;
  title2: string;
  fontsize1: number;
  fontsize2: number;
  subtitle: string;
  movie: any;
  placeholder: string;
  accordion: any;
  body: any;
  intro: any;
  titleColor?: 'primary' | 'muted';
};
// ============================================================

const FAQ2: FC<Faq2Props> = ({
  title1,
  title2,
  subtitle,
  placeholder,
  movie,
  accordion,
  intro,
  fontsize1,
  fontsize2,
  titleColor = 'primary'
}) => {
  return (
    <section id="point-process" className="video-hero wrapper angled lower-start pt-15 pt-md-17">
      <h2>
        <span className="hero_text">
          <p className={`fs-${fontsize1}`}>{title1}</p>
          <span className={`fs-${fontsize2}`}>{title2}</span>
        </span>

        <video autoPlay loop playsInline muted poster={placeholder}>
          <source src={movie} type="video/mp4" />
        </video>
      </h2>
      <div className="row animate__animated animate__slideInUp animate__delay-2s">
        <div className=" col-12 mx-auto text-center mt-5">
          {/* <h3 className="display-4 mb-5 text-capitalize" style={{  }}>
            for SEO Success<br></br>
            <span style={{ fontSize: 20 }}>- AI driven {subtitle} -</span>
          </h3> */}
        </div>
      </div>
      <div className="row animate__animated animate__slideInUp animate__delay-2s">
        <div className="col-10 col-md-11 mx-auto text-center mb-10">
          <p className="lead fs-5">{intro}</p>
        </div>
      </div>
      <div className="row w-100 mb-md-20">
        <div className="mx-auto col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <ol className="animate__animated animate__slideInUp animate__delay-3s accordion-wrapper w-100 p-0" id="accordion" >
            {accordion.map((item: any) => (
              <Accordion key={item.no} {...item} />
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default FAQ2;
